type Props = {
  size?: number;
  colorA?: string;
  colorB?: string;
  className?: string;
};

const CheckerDivider = ({
  size = 56,
  colorA = "#571310",
  colorB = "#fffcef",
  className = "",
}: Props) => (
  <div
    aria-hidden
    className={`w-full ${className}`}
    style={{
      height: size * 2,
      backgroundImage: `conic-gradient(${colorA} 25%, ${colorB} 0 50%, ${colorA} 0 75%, ${colorB} 0)`,
      backgroundSize: `${size * 2}px ${size * 2}px`,
      backgroundPosition: "0 0",
    }}
  />
);

export default CheckerDivider;
